import { SortableHeaderProps, TableCellWidth } from '@app/src/components/Table'
import TableHeaderCell from '@app/src/components/Table/Cells/TableHeaderCell'
import { TableRow } from '@mui/material'

import * as React from 'react'
import { useIntl } from 'react-intl'

interface SentMappingRequestHeaderProps extends SortableHeaderProps {
  isHeaderChecked?: boolean
  handleHeaderCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
}

function SentMappingRequestHeader({
  toggleSorting,
  activeSorting,
  handleHeaderCheckboxChange,
  isHeaderChecked,
}: SentMappingRequestHeaderProps) {
  const { formatMessage } = useIntl()

  return (
    <TableRow>
      <TableHeaderCell
        label=""
        checkbox={{ checked: isHeaderChecked, onChange: handleHeaderCheckboxChange, color: 'primary' }}
        minWidth={TableCellWidth.EMPTY}
      />
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.mappingRequest.status' })}
        sorting={{ name: 'status', toggleSorting, activeSorting }}
        minWidth={TableCellWidth.SMALL}
      />
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.mappingRequest.productName' })}
        sorting={{ name: 'product.name', toggleSorting, activeSorting }}
        minWidth={TableCellWidth.EXTRA_LARGE}
      />
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.mappingRequest.sentTo' })}
        sorting={{ name: 'responderOrganization.name', toggleSorting, activeSorting }}
      />
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.mappingRequest.deadline' })}
        sorting={{ name: 'deadline', toggleSorting, activeSorting }}
      />
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.mappingRequest.period' })}
        sorting={{ name: 'periodName', toggleSorting, activeSorting }}
        minWidth={TableCellWidth.SMALL}
      />
    </TableRow>
  )
}

export default SentMappingRequestHeader
